import { useFormContext } from 'react-hook-form';
import { DebounceClick } from '@toss/react';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { PlanCheckoutFormSchemaType, useSubscriptionPaymentContext, useSubscriptionPaymentLog } from '../hooks';
import { usePaymentAction } from '../hooks/usePaymentAction';
export const PaymentForeignSubmit = ({
  isAgree
}: {
  isAgree: boolean;
}) => {
  const {
    isUpdated,
    isUpdatePayment,
    isSubmitLoading,
    isRegisterCard,
    amplitudeData,
    isAnnuallyPayment
  } = useSubscriptionPaymentContext();
  const send = useSubscriptionPaymentLog('payment_subscription_purchase', false, isAnnuallyPayment ? 'Annual' : 'Monthly');
  const {
    formState: {
      errors
    }
  } = useFormContext<PlanCheckoutFormSchemaType>();
  const {
    subscribePlan: _subscribePlan
  } = usePaymentAction();
  const {
    t
  } = useTranslation(['subscription']);
  const subscribePlan = async () => {
    try {
      // 결제하기 시도시에 하기로합의
      send(amplitudeData);
      await _subscribePlan({
        retry: async () => {
          await subscribePlan();
        }
      }, false);
    } catch (e) {
      console.error(e, 'subscribePlan');
    }
  };
  const enabled = (() => {
    // 업데이트 상황이면서
    if (isUpdated && !isUpdatePayment && isAgree) return true;
    //  loading 상태
    if (isSubmitLoading || !isRegisterCard) return false;
    return isAgree;
  })();
  return <DebounceClick wait={200} data-sentry-element="DebounceClick" data-sentry-component="PaymentForeignSubmit" data-sentry-source-file="PaymentForeignSubmit.tsx">
      <Button isFullWidth size={'md'} disabled={!enabled || Object.keys(errors).length > 0} isLoading={isSubmitLoading} onClick={subscribePlan} data-sentry-element="Button" data-sentry-source-file="PaymentForeignSubmit.tsx">
        {t('subscription:payment.summaryCommon.buttonPay')}
      </Button>
    </DebounceClick>;
};